import React, { createRef } from "react";
import { Typography } from "@mui/material";
import { withTranslation } from "react-i18next";
import { sendLog } from "../../utils/sa-log";
import { CommonFunctions } from "src/utils";
import "./style.scss";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Checkbox } from "oneui";
import BubbleBox from '../BubbleBox';

const TEXT_COLOR_ITEM = "#010102";
const BACK_GR_COLOR = "#F1F1F3";
const BACK_GR_COLOR_DARKMODE = "#2D2D30";
const DESCRIPTION_COLOR = "#8C8C91";
const OPTIONAL_TEXT_COLOR = "#4D4D52";

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
    };
    this.buttonRef = createRef();
    this.timeoutId = null;
  }

  handleTouchStart = () => {
    this.timeoutId = setTimeout(() => {
      this.setState({ showTooltip: true });
    }, 500);
  };

  handleTouchEnd = () => {
    clearTimeout(this.timeoutId);
  };

  closeLabelToast = () => {
    this.setState({ showTooltip: false });
  };

  onChange = (isChecked) => {
    CommonFunctions.debugLog("Checkbox clicked");
    if (this.props.onChange != null) {
      const { pageId, checkboxId } = this.props.analyticIds;
      if (!CommonFunctions.isUndefinedOrNull(pageId) && !CommonFunctions.isUndefinedOrNull(checkboxId)) {
        sendLog(pageId, checkboxId, isChecked ? 1 : 0);
      }
      this.props.onChange(isChecked, this.props.id);
    }
  };

  onLabelClick = (e) => {
    CommonFunctions.debugLog("Label clicked");
    const { pageId, labelId } = this.props.analyticIds;
    if (!CommonFunctions.isUndefinedOrNull(pageId) && !CommonFunctions.isUndefinedOrNull(labelId)) {
      sendLog(pageId, labelId);
    }
  };

  onDetailsClick = (e) => {
    e.stopPropagation(); // not trigger event click checkbox area when click detail link
    window.open(this.props.detail, "_blank");
    CommonFunctions.debugLog("Detail clicked");
    const { pageId, detailsId } = this.props.analyticIds;
    if (pageId !== null && detailsId !== null) {
      sendLog(pageId, detailsId);
    }
  };

  render() {
    const { detail, checked, disabled, id, title, description, theme, t } = this.props;
    const { showTooltip } = this.state;
    let backGrColor = BACK_GR_COLOR;
    let titleCheckbox = title;
    let descriptionColor = DESCRIPTION_COLOR;
    let titleColor = TEXT_COLOR_ITEM;
    let optionalTextColor = OPTIONAL_TEXT_COLOR;

    if (!!theme) {
      if (theme.palette.type === "dark") {
        backGrColor = BACK_GR_COLOR_DARKMODE;
      }
      titleColor = theme.palette.text.checkboxTitle;
      optionalTextColor = theme.palette.text.optionalText;
      descriptionColor = theme.palette.text.checkboxDescription;
    }

    const getTitle = () => {
      const formatTitle = () => {
        return titleCheckbox.replace(/\((.*?)\)/g, (match) => {
          return `<span class="optional-text" style="color: ${optionalTextColor}">${match}</span>`
        })
      }
      return (
        <span dangerouslySetInnerHTML={{ __html: formatTitle() }} />
      )
    }

    return (
      <div className={`checkbox-item${checked ? " checkbox-item-checked" : ""}`} style={{ backgroundColor: backGrColor }} onClick={() => this.onChange(!checked)}>
        <div className="checkbox-wrapper">
          <div className="checkbox-left-side">
            <Checkbox id={id} checked={checked} disabled={disabled} className={`checkbox-label${checked ? " checkbox-label-checked" : ""}`} />
          </div>
          <div className="checkbox-right-side">
            <div
              className={`checkbox-title${!description ? " margin-text-bottom" : ""}`}
              onClick={this.onLabelClick}
            >
              <Typography
                color={titleColor}
                id={id + "-label"}
              >
                {getTitle()}
              </Typography>
            </div>
          </div>
          {detail && (
            <div className="checkbox-details">
              <div className="checkbox-details-btn">
                <button
                  id={id + "-detail"}
                  className="checkbox-details-icon"
                  onClick={this.onDetailsClick}
                  target={"_blank"}
                  href={detail}
                  onTouchStart={this.handleTouchStart}
                  onTouchEnd={this.handleTouchEnd}
                  onTouchCancel={this.handleTouchEnd}
                  aria-label={t('detail')}
                  ref={this.buttonRef}
                >
                  <ArrowForwardIosIcon fontSize='small' />
                </button>
              </div>
              {showTooltip && <BubbleBox targetRef={this.buttonRef} onClose={this.closeLabelToast} theme={theme} text={t('detail')} id={id} />}
            </div>
          )}
        </div>
        {description && (
          <div className={"checkbox-description margin-text-bottom"} style={{ color: descriptionColor }}>
            {description}
          </div>
        )}
      </div>
    );
  }
}

Item.defaultProps = {
  analyticIds: {
    pageId: null,
    checkboxId: null,
    labelId: null,
    detailsId: null,
  },
};

export default withTranslation()(Item);
